import { RedirectToMissionsPage } from 'components/missions/RedirectToMissionsPage';

const MissionsPage = () => {
  return <RedirectToMissionsPage />;
};

export default MissionsPage;
